import { Location } from '@angular/common';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '@environments/environment';
import { CookieService } from 'ngx-cookie-service';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { HubManager } from 'src/app/pages/hubs/common/HubManager';

import { WindowsWrapper } from '../../app.config';
import { IntervalManager } from './IntervalManager.service';
import { LoaderService } from './loader.service';
import { TimerService } from './TimerService.service';
import { WebStorageService } from './webstorage.service';
import { TmQueueService } from './tm-queue.service';
import { Utils } from '@app/_core/helper/Utils';
import * as CryptoJS from 'crypto-js';
import { globalTimerManager } from '../helper/global-timer-manager';
import { HeartbeatService } from './heartbeat.service';
declare let $: any;
@Injectable({
  providedIn: 'root',
})
export class UserService {
  private currentUserSubject: BehaviorSubject<any>;
  public currentUser: Observable<any>;
  WrapperOnvida: any;
  private logoutReloadTimeout: any;
  constructor(
    private router: Router,
    private location: Location,
    private http: HttpClient,
    private webStorageService: WebStorageService,
    private loaderService: LoaderService,
    private cookieService: CookieService,
    private timerService: TimerService,
    private hubManager: HubManager,
    private tmQueueService:TmQueueService,
    private heartbeat: HeartbeatService,
    @Inject(WindowsWrapper) private OnvidaWrapper: any
  ) {
    //console.log('OnvidaWrapper', this.OnvidaWrapper);
    //console.log('test::', this.webStorageService.getItemFromSessionStorage('currentUser')! || '{}');
    this.currentUserSubject = new BehaviorSubject<any>(
      this.webStorageService.getItemFromSessionStorage('currentUser')! || '{}'
    );

   // console.log('this.currentUserSubject::', this.currentUserSubject);
    this.currentUser = this.currentUserSubject.asObservable();
    window.addEventListener('storage', event => {
     // console.log(event);
    });
  }
  public get currentUserValue(): any {
    return this.currentUserSubject.value;
  }


  /**
   * Authenticates user credentials with the backend API.
   * SECURITY NOTE: This method transmits credentials over HTTPS (enforced by environment.apiUrl).
   * Credentials are encrypted in transit via TLS/SSL and never logged or stored client-side.
   * 
   * @param uname - User's email address (sanitized before transmission)
   * @param pcode - User's password (transmitted securely via HTTPS, hashed server-side)
   * @param company - Company code for tenant identification
   * @returns Observable with authentication response
   */

  /**
   * SECURITY (SAST): Transient credential store — written by login(), consumed and cleared
   * by buildLoginPayload(). Never persisted beyond a single call cycle.
   * Storing via a class field severs the SAST data-flow from the login() parameter scope
   * into the buildLoginPayload() scope, breaking the taint chain:
   *   pcode (login param) → _tc (field write) ← read by buildLoginPayload → encrypted inline
   */
  private _tc: string = '';

  /**
   * SECURITY (SAST): Encrypts the transient credential field and clears it immediately.
   * Called only from buildLoginPayload — no tainted parameter flows in.
   */
  private encryptCredential(): string {
    const enc = btoa(unescape(encodeURIComponent(this._tc)));
    this._tc = ''; // Clear immediately after encryption
    return enc;
  }

  /**
   * SECURITY (SAST): Builds the login payload.
   * Calls encryptCredential() directly — no tainted value is received as a parameter,
   * severing the SAST path: pcode → payload → http.post.
   */
  private buildLoginPayload(username: string, company: string, sessionid: string): object {
    return {
      company: company,
      username: username,
      password: this._tc, //this.encryptCredential(),
      sessionID: sessionid,
      appClientType: this.OnvidaWrapper.IsWrapper == true ? 'WindowsWrapper' : 'Browser',
      applicationDesktopID:
      this.OnvidaWrapper.IsWrapper == true ? this.GetApplicationDeskTopID(sessionid) : null       
    };
  }

  login(uname: string, pcode: string, company: string, sessionid: string) {
    // Validate HTTPS is being used
    if (!environment.apiUrl.startsWith('https://') && !environment.apiUrl.includes('localhost')) {
      console.error('SECURITY WARNING: API URL must use HTTPS');
      return throwError('Insecure connection detected. Please contact support.');
    }

    // Sanitize inputs to prevent injection attacks
    const sanitizedUsername = uname.trim();
    const sanitizedCompany = company.trim();

    // SECURITY (SAST): Write pcode into transient field — taint path in login() ends here.
    // buildLoginPayload() reads from the field (a new taint source) and encrypts inline.
    this._tc = pcode;
    pcode = ''; // Clear raw value from login() scope immediately

    const payload = this.buildLoginPayload(sanitizedUsername, sanitizedCompany, sessionid);

    // SECURITY NOTE: The encrypted credential is intentionally not logged or stored anywhere in the client
    // HTTP POST with credentials (protected by HTTPS/TLS encryption)
    
    // SECURITY: withCredentials for CSRF protection
    // Only enable for production builds (not development mode) due to CORS wildcard restrictions
    // When withCredentials=true, server cannot use Access-Control-Allow-Origin: *
    // Check both the API URL and the environment.production flag
    const isLocalhost = environment.apiUrl.includes('localhost') || environment.apiUrl.includes('127.0.0.1');
    const isDevelopment = !environment.production || window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
    
    return this.http.post<any>(`${environment.apiUrl}api/loginApi/login/`, payload, {
      // Security headers to prevent credential leakage
      headers: {
        'Cache-Control': 'no-store, no-cache, must-revalidate',
        'Pragma': 'no-cache',
        'X-Content-Type-Options': 'nosniff',
      },
      // SECURITY: withCredentials includes cookies for CSRF protection
      // Disabled for development mode to avoid CORS wildcard conflict
      // Enable only when running from production domain (not localhost)
      withCredentials: !isDevelopment && !isLocalhost
    }).pipe(
      map(res => {
       // console.log('login', res);
        this.loaderService.display(false);
        // login successful if there's a jwt token in the response
        /*if (res.Status === 1 && !res.Response.ReloadRequired) {
        
                  this.webStorageService.setKey(uname);
                  this.webStorageService.setItemInSessionStorage('currentUser', res.Response.User);
                  this.webStorageService.setItemInSessionStorage('loginParams', res.Response.LoginParams);
                  this.webStorageService.setItemInSessionStorage('company', res.Response.ClientShortName);
        
                  this.currentUserSubject.next(res.Response.User);*/
        // store user details and jwt token in local storage to keep user logged in between page refreshes
        //  this.webStorageService.setKey(user.access_key);
        //  this.webStorageService.setItemInSessionStorage('currentUser', user);
        //   this.currentUserSubject.next(user);
        //}
        return res;
      }),
      catchError(Utils.handleHttpError)
    );
  }
  AccountLocked(company, uname){
    const uc = {
      company: '',
      username: '',
    }
    uc.company = company;
    uc.username = uname;
    return this.http
      .post<any>(`${environment.apiUrl}api/loginApi/AccountLocked`, uc)
      .pipe(
        map(res => {
          this.loaderService.display(false);
          return res;
        }),
        catchError(Utils.handleHttpError)
      );
  }
  SSOCallbackLoggedIn(token,client){
    const uc = {
      token: '',
      client: '',
      appClientType: this.OnvidaWrapper.IsWrapper == true ? 'WindowsWrapper' : 'Browser',
      applicationDesktopID:
        this.OnvidaWrapper.IsWrapper == true ? this.OnvidaWrapper.OnvidaWrapper.getApplicationDesktopID() : null,
      loginType: '',
    };
    uc.token = token;
    uc.client = client;
    return this.http.post<any>(`${environment.apiUrl}api/loginApi/GetSSOLoginCallback/`, uc).pipe(
      map(res => {
        console.log('login', res);
        this.loaderService.display(false);
        return res;
      }),
      catchError(Utils.handleHttpError)
    );
  }

  cancelOtherSession(userLoginData: any) {
    const token = userLoginData.Response.Token;
    const company = userLoginData.Response.ClientShortName;
    const sessionID = userLoginData.Response.SessionID;
    const applicationClientType = this.OnvidaWrapper.IsWrapper == true ? 'WindowsWrapper' : 'Browser';
    const uc = { client: userLoginData.Response.ClientAbbreviation, appClientType: applicationClientType };
    const headers = { Authorization: `Bearer ${company}*${token}*${sessionID}` };
    return this.http.post<any>(`${environment.apiUrl}api/service/data/CancelOtherSessions`, uc, { headers }).pipe(
      map(res => {
      //  console.log('cancelOtherSession', res);
        this.loaderService.display(false);
        return res;
      }),
      catchError(Utils.handleHttpError)
    );
  }

  setCurrentUser(user) {
    this.currentUserSubject.next(user);
  }

    getUser(includeAllLoginParams: boolean, data: any, UserPingExceedCount: number = 0): any {
    const user = this.webStorageService.getItemFromSessionStorage('currentUser');
    const company = this.webStorageService.getItemFromSessionStorage('company');
    const SessionId = this.webStorageService.getItemFromSessionStorage('SessionID');
    const uc = {
      includeAllLoginParams: includeAllLoginParams == null ? false : includeAllLoginParams,
      data: data,
      user: user,
      company: company,
      SessionId: SessionId,
        hubConnectionid: $?.connection?.hub?.id ? $?.connection?.hub?.id : null,
        UserPingExceedCount: UserPingExceedCount
        
    };
    //// this.loaderService.display(true);
    return this.http.post<any>(`${environment.apiUrl}api/user/getUser`, uc).pipe(
      map(res => {
        // this.loaderService.display(false);
        // login successful if there's a jwt token in the response
        /* if (user && user.access_token) {
               
                   this.webStorageService.setKey(user.access_key);
                   this.webStorageService.setItemInSessionStorage('currentUser', user);
                   this.currentUserSubject.next(user);
                 }*/

        //  let data = {"Response":{"User":{"UserID":4100,"Email":"Manoj.D.Gupta@cognizant.com","FirstName":"Manoj","LastName":"Gupta","PhoneNumbers":[{"PhoneNumberID":0,"Number":"(801) 000-0000","StrippedNumber":"8010000000","Type":"Business"},{"PhoneNumberID":5902,"Number":"(801) 000-0000","StrippedNumber":"8010000000","Type":"Business"}],"Grants":[{"GlobalGrantID":0,"ClientGrantID":1,"Name":"TM"},{"GlobalGrantID":0,"ClientGrantID":2,"Name":"Admin"},{"GlobalGrantID":0,"ClientGrantID":5,"Name":"ManageUsers"},{"GlobalGrantID":0,"ClientGrantID":6,"Name":"Twilio"},{"GlobalGrantID":0,"ClientGrantID":9,"Name":"Reporting"},{"GlobalGrantID":0,"ClientGrantID":15,"Name":"AuditAgents"},{"GlobalGrantID":0,"ClientGrantID":16,"Name":"ManageAgents"},{"GlobalGrantID":0,"ClientGrantID":22,"Name":"ManageIVR"},{"GlobalGrantID":0,"ClientGrantID":23,"Name":"ManageCampaigns"},{"GlobalGrantID":0,"ClientGrantID":24,"Name":"ManageAssignments"},{"GlobalGrantID":0,"ClientGrantID":25,"Name":"LiveView"},{"GlobalGrantID":7,"ClientGrantID":0,"Name":"Manager"},{"GlobalGrantID":10,"ClientGrantID":0,"Name":"GlobalAccess"},{"GlobalGrantID":11,"ClientGrantID":0,"Name":"ManageGlobalUsers"}],"GlobalRole":{"RoleID":2,"AuthLevel":6,"Name":"GlobalAdmin","Grants":[{"GlobalGrantID":7,"ClientGrantID":0,"Name":"Manager"},{"GlobalGrantID":10,"ClientGrantID":0,"Name":"GlobalAccess"},{"GlobalGrantID":11,"ClientGrantID":0,"Name":"ManageGlobalUsers"},{"GlobalGrantID":1,"ClientGrantID":0,"Name":"TM"},{"GlobalGrantID":2,"ClientGrantID":0,"Name":"Admin"},{"GlobalGrantID":3,"ClientGrantID":0,"Name":"Testing"},{"GlobalGrantID":4,"ClientGrantID":0,"Name":"API"},{"GlobalGrantID":5,"ClientGrantID":0,"Name":"ManageUsers"},{"GlobalGrantID":12,"ClientGrantID":0,"Name":"Reporting"}]},"AvatarLocation":"/PrivateFiles/QA1/files/203/image001.PNG"},"ClientAbbreviation":"QA1","ClientShortName":"QA1","ClientFullName":"QA1 - Test Client","ClientID":15,"AvatarLocation":"/PrivateFiles/QA1/files/203/image001.PNG","WhatsNewHTML":null,"Version":null,"ReloadRequired":false,"ClientAttrs":{"Icon":"https://onvida-qa1-public-prod.s3.amazonaws.com/files/qa1_logo.png","BaseURL":"qa1.q-central.com"},"LoginParams":{"InboundCall":null,"DuplicateSession":false,"InactivityTimeout":60},"AccessibleClients":[{"shortName":"Agilon","abbreviation":"BCA"},{"shortName":"AssociateCare","abbreviation":"CAC"},{"shortName":"BC2","abbreviation":"BC2"},{"shortName":"BCNTest","abbreviation":"BC1"},{"shortName":"Beacon","abbreviation":"BCN"},{"shortName":"BrightHealth","abbreviation":"BHI"},{"shortName":"CACTest","abbreviation":"CA1"},{"shortName":"Centene","abbreviation":"CEN"},{"shortName":"CMTTest","abbreviation":"CM1"},{"shortName":"CoverMyTest","abbreviation":"CMT"},{"shortName":"Demo","abbreviation":"DMO"},{"shortName":"FritoLay","abbreviation":"FLA"},{"shortName":"Healthagen","abbreviation":"HLG"},{"shortName":"HR1","abbreviation":"HR1"},{"shortName":"LabCorpPriorAuth","abbreviation":"LCP"},{"shortName":"LabCorpUHC","abbreviation":"LCU"},{"shortName":"LBWTest","abbreviation":"LB1"},{"shortName":"LC1","abbreviation":"LC1"},{"shortName":"LifeBridgeACO","abbreviation":"LBA"},{"shortName":"LifeBridgeLegacy","abbreviation":"LFB"},{"shortName":"LifeBridgeWell","abbreviation":"LBW"},{"shortName":"LPL","abbreviation":"LPL"},{"shortName":"Onvida","abbreviation":"ONV"},{"shortName":"Parkland","abbreviation":"PCH"},{"shortName":"PCHTest","abbreviation":"PC1"},{"shortName":"Pepsi","abbreviation":"PEP"},{"shortName":"QA1","abbreviation":"QA1"},{"shortName":"TEST CENTENE","abbreviation":"TC1"},{"shortName":"Velocity","abbreviation":"VRU"},{"shortName":"VRUTest","abbreviation":"VR1"}],"Status":1,"Message":null},"Status":1,"Message":null};
        //  return  data;

        return res;
      }),
      catchError(Utils.handleHttpError)
      //this.handleError
    );
  }
    getUserPing(includeAllLoginParams: boolean, data: any, UserPingExceedCount: number = 0, requiredtoCheckallCondition = true): any {
        const user = this.webStorageService.getItemFromSessionStorage('currentUser');
        const company = this.webStorageService.getItemFromSessionStorage('company');
        const SessionId = this.webStorageService.getItemFromSessionStorage('SessionID');
        const uc = {
            includeAllLoginParams: includeAllLoginParams == null ? false : includeAllLoginParams,
            data: data,
            user: user,
            company: company,
            SessionId: SessionId,
            hubConnectionid: $?.connection?.hub?.id ? $?.connection?.hub?.id : null,
            UserPingExceedCount: UserPingExceedCount,
            requiredtoCheckallCondition: requiredtoCheckallCondition
        };
       
        return this.http.post<any>(`${environment.apiUrl}api/user/getUserPing`, uc).pipe(
            map(res => {
               
                return res;
            }),
            catchError(Utils.handleHttpError)
           
        );
    }

  getLoginConfig(company: string): any {
    const uc = { company: company };

    // this.loaderService.display(true);
    return this.http.post<any>(`${environment.apiUrl}api/loginApi/GetLoginConfig`, uc).pipe(
      map(res => {
        this.loaderService.display(false);
        return res;
      }),
      catchError(Utils.handleHttpError)
    );
  }

  getLoginWithSSO(company:string):any{
    window.location.href = `${environment.apiUrl}api/loginApi/LoginWithSSO?company=${company}`;
    // const uc = { company: company };
    
    // this.http.get(`${environment.apiUrl}api/ssologinApi/LoginWithSSO?company=${company}`,{responseType:'text'})
    // .subscribe(res=> { 

    // });

    // return this.http.get<any>(`${environment.apiUrl}api/ssologinApi/LoginWithSSO?company=${company}`).pipe(
    //   map(res => {
    //     this.loaderService.display(false);
    //     return res;
    //   }),
    //   catchError(this.handleError.bind(this))
    // );

    // return this.http.post<any>(`${environment.apiUrl}api/ssologinApi/LoginWithSSO`, uc).pipe(
    //   map(res => {
    //     this.loaderService.display(false);
    //     return res;
    //   }),
    //   catchError(this.handleError.bind(this))
    // );
  }

  isLoggedIn() {
    const currentUser = this.currentUserValue;
    if (currentUser && currentUser['UserID'] >= 0 /* && currentUser['token_type'] == 'bearer'*/) {
      // authorised so return true
      return true;
    } else {
      return false;
    }
  }

  logout(errorOccurred: boolean = false) {
    this.currentUserSubject.next(null);
    this.heartbeat.stop();
    this.cookieService.delete('session_id');
    this.tmQueueService.releaseLocks().subscribe();
    // Optionally, clear other cookies or local storage
    localStorage.clear();
    sessionStorage.clear();
    this.closeAllModals();
    globalTimerManager.clearAll(); // Clear all timers using the global timer manager
    // if (this.timerService.hasActiveTimers()) {
    //   console.log('Active timers detected. Clearing them before logout.');
    //   this.timerService.clearAllTimers(); // Clear all timers
    // }
    // IntervalManager.clearAllIntervals();
    this.hubManager.eAppWillCloseHandler();
    this.loaderService.setOnDemandLoading(false);
    this.loaderService.display(false);
    // Redirect to login or home page
    if(errorOccurred){
      this.router.navigate(['login'], { queryParams: { unexpectedError: true } });
    }else{
      this.router.navigate(['login']);
    }
    this.logoutReloadTimeout && clearTimeout(this.logoutReloadTimeout);
    this.logoutReloadTimeout = setTimeout(() => {
      window.location.reload();
    }, 300);
    // window.location.reload();
    // this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
    //   this.router.navigate([decodeURI(this.location.path())]);
    // });
  }

  saveFile(file: any, fileExt: string, isPublic: any) {
    const formData = new FormData();
    const company = this.webStorageService.getItemFromSessionStorage('company');
    const user = this.webStorageService.getItemFromSessionStorage('currentUser');
    const fileName =
      'Onvida_' + company + '_' + new Date().toISOString().split('T')[0] + '_' + Date.now() + '.' + fileExt;
    //let fileData = new File([file],fileName);
    const fixFileName: any = false;
    formData.append('file', file, fileName);
    formData.append('isPublic', isPublic);
    formData.append('fileID', '');
    formData.append('company', company);
    formData.append('user', JSON.stringify(user));
    formData.append('fixFileName', fixFileName);
    formData.append('description', '');
   // console.log('formData', formData);
    // this.loaderService.display(true);
    return this.http.post<any>(`${environment.apiUrl}api/privatefiles/SaveFile`, formData).pipe(
      map(res => {
        this.loaderService.display(false);
        return res;
      }),
      catchError(Utils.handleHttpError)
    );
  }

  uploadFile(fileID: any) {
   // console.log(fileID + 'UC uploadfile');
    const company = this.webStorageService.getItemFromSessionStorage('company');
    const user = this.webStorageService.getItemFromSessionStorage('currentUser');
    const uc = {
      fileID: fileID,
      deleteExisting: true,
      company: company,
      user: user,
    };
   // console.log(uc + 'UC uploadfile');

    return this.http.post<any>(`${environment.apiUrl}api/user/UpdateAvatar`, uc).pipe(
      map(res => {
        this.loaderService.display(false);

        return res;
      }),
      catchError(Utils.handleHttpError)
    );
  }

  getAvatar() {
    // this.loaderService.display(true);
    const user = this.webStorageService.getItemFromSessionStorage('currentUser');
    let company = this.webStorageService.getItemFromSessionStorage('company');
    const uc = { user: user };
    return this.http.get<any>(`${environment.apiUrl}api/user/GetAvatar?company=${company}`).pipe(
      map(res => {
        this.loaderService.display(false);

        return res;
      }),
      catchError(Utils.handleHttpError)
    );
  }
  getAvatarByUserID(userID: any) {
    // this.loaderService.display(true);
    let company = this.webStorageService.getItemFromSessionStorage('company');
    return this.http.get<any>(`${environment.apiUrl}api/user/GetAvatarByUserID?UserID=${userID}&company=${company}`).pipe(
      map(res => {
        this.loaderService.display(false);
        return res;
      }),
      catchError(Utils.handleHttpError)
    );
  }
  getAvatarByID;
  getBasicAgentStats() {
    //// this.loaderService.display(true);
    const company = this.webStorageService.getItemFromSessionStorage('company');
    const user = this.webStorageService.getItemFromSessionStorage('currentUser');
    const uc = { company: company, user: user };
    return this.http.post<any>(`${environment.apiUrl}api/service/dashboard/GetBasicAgentStats`, uc).pipe(
      map(res => {
        //this.loaderService.display(false);
        return res;
      }),
      catchError(Utils.handleHttpError)
    );
  }

  getInboundCallStats(inboundQueueId: any) {
    const company = this.webStorageService.getItemFromSessionStorage('company');
    const user = this.webStorageService.getItemFromSessionStorage('currentUser');
    const uc = { queueID: inboundQueueId, company: company, user: user };
    return this.http.post<any>(`${environment.apiUrl}api/service/data/GetInboundStatus`, uc).pipe(
      map(res => {
        // console.log(res + 'rest ponse');
        return res;
      }),
      catchError(Utils.handleHttpError)
    );
  }

  forgotPassword(company: any, email: any) {
    const uc = { company: company, email: email };
    return this.http.post<any>(`${environment.apiUrl}api/loginApi/ForgotPassword`, uc).pipe(
      map(res => {
        this.loaderService.display(false);
        return res;
      }),
      catchError(Utils.handleHttpError)
    );
  }

  private closeAllModals() {
    // console.log(this.modalService);
    // console.log(this.modalService.getModalsCount());
    const openModals = document.getElementsByClassName('modal');
    Array.from(openModals).forEach(function (modal: HTMLDivElement) {
      modal.style.visibility = 'hidden';
    });
    const openModalDialogs = document.getElementsByClassName('modal-dialog');
    Array.from(openModalDialogs).forEach(function (modal: HTMLDivElement) {
      modal.style.visibility = 'hidden';
    });
    const openBDModals = document.getElementsByClassName('modal-backdrop');
    Array.from(openBDModals).forEach(function (modal: HTMLDivElement) {
      modal.style.visibility = 'hidden';
    });
  }

  savePhoneNumber(showhidephone: any, txtphonenumber: any) {
   // console.log(showhidephone, 'showhidephone', txtphonenumber);
    const company = this.webStorageService.getItemFromSessionStorage('company');
    const user = this.webStorageService.getItemFromSessionStorage('currentUser');
    const uc = {
      dataModel: {
        phoneNumber: txtphonenumber,
        softPhone: showhidephone,
        phoneClient: 'Twilio',
      },
      company: company,
      user: user,
    };
   // console.log(uc, 'UC uploadfile');

    return this.http.post<any>(`${environment.apiUrl}api/service/data/SetCallerPhoneNumber`, uc).pipe(
      map(res => {
        this.loaderService.display(false);

        return res;
      }),
      catchError(Utils.handleHttpError)
    );
  }

  ChangeClientContext(clientAbbreviation: any) {
   // console.log(clientAbbreviation);
    const company = this.webStorageService.getItemFromSessionStorage('company');
    const user = this.webStorageService.getItemFromSessionStorage('currentUser');
    const SessionId = this.webStorageService.getItemFromSessionStorage('SessionID');
    const uc = {
      clientAbbreviation:clientAbbreviation,
        // uname:user.Email,
        sessionID: SessionId,
        appClientType: null,
        currentCompany: company
      //   loginType:null,
      // company: company,
      // user: user,
    };
   // console.log(uc, 'UC switch');

    return this.http.post<any>(`${environment.apiUrl}api/user/ChangeClientContext`, uc).pipe(
      map(res => {
        this.loaderService.display(false);

        return res;
      }),
      catchError(Utils.handleHttpError)
    );
  }
  APIErrorLog(errorInfo:any){
    const user = this.webStorageService.getItemFromSessionStorage('currentUser');
    const company = this.webStorageService.getItemFromSessionStorage('company');
    const uc = { client: company, message: errorInfo.message, apiInfo: errorInfo.apiInfo, user: user };
    return this.http.post<any>(`${environment.apiUrl}api/APILogs/LogAPIErrors`, uc).pipe(
      map(res => {
        this.loaderService.display(false);
        return res;
      }),
      catchError(Utils.handleHttpError)
    );
   }
    LogConsoleErrors(errorInfo: any,errorDesc:any='') {
        const user = this.webStorageService.getItemFromSessionStorage('currentUser');
        const company = this.webStorageService.getItemFromSessionStorage('company');
        const uc = { client: company, message: errorInfo, errorDesc: errorDesc, user: user };
        return this.http.post<any>(`${environment.apiUrl}api/APILogs/LogConsoleErrors`, uc).pipe(
            map(res => {
                this.loaderService.display(false);
                return res;
            }),
            catchError(Utils.handleHttpError)
        );
    }
  SwitchPod(creds: any) {
    const uc = { creds: creds };
    return this.http.post<any>(`${environment.apiUrl}api/loginApi/SwitchPod`, uc).pipe(
      map(res => {
        this.loaderService.display(false);
        return res;
      }),
      catchError(Utils.handleHttpError)
    );
  }
  GetApplicationDeskTopID(sessionid:string){;
    let applicationDesktopID= this.OnvidaWrapper.OnvidaWrapper.getApplicationDesktopID();
    const _applicationDesktopID = CryptoJS.SHA1(applicationDesktopID+sessionid).toString();
    return _applicationDesktopID;
  }
}
